import {ArrayTyper} from '@caliatys/array-typer';

export class Page<T> {
  page: PageInfo;
  content: T[];

  constructor(c: new (object: any, ...args: any[]) => T, obj: any) {
    this.content = ArrayTyper.asArray(c, obj?.content);
    this.page = new PageInfo(obj?.page);
  }
}

export class PageInfo {
  currentPage: number;
  hasMore: boolean;
  limit: number;
  maxPage: number;
  total: number;

  constructor(obj: any) {
    this.currentPage = obj?.curPage;
    this.hasMore = obj?.hasMore;
    this.limit = obj?.limit;
    this.maxPage = obj?.maxPage;
    this.total = obj?.total;

  }
}

export class Filter {
  criteriaKey?: string;
  criteriaLabel?: string;
  label?: string;
  value?: any;
  dateLabel?: string;
}

